export default {
  NORMAL: "NORMAL",
  NOT_IN_LIMITS: "NOT_IN_LIMITS",
  EXCESS_BY_AMOUNT: "EXCESS_BY_AMOUNT",
  EXCESS_BY_QUANTITY: "EXCESS_BY_QUANTITY",
  ONLY_MAIN_INSURED: "ONLY_MAIN_INSURED"
};
